import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import backButton from "./Images/back.png";

const CustomChair = () => {
  const userEmail = sessionStorage.getItem("userEmail");
  const navigate = useNavigate();
  const [folderName, setFolderName] = useState("default");
  const [customchairUrl, setCustomchairUrl] = useState("");
  const [glbUrl, setGlbUrl] = useState("");

  const [inputs, setInputs] = useState({
    seat_width: "",
    seat_depth: "",
    seat_thickness: "",
    leg_height: "",
    leg_width: "",
    backrest_height: "",
    backrest_thickness: "",
    armrest_height_above_seat: "",
    armrest_thickness: "",
    armrest_width: "",
  });

  // Redirect if not signed in
  useEffect(() => {
    if (!userEmail) navigate("/signin");
  }, [userEmail, navigate]);

  // Inject model-viewer script once
  useEffect(() => {
    if (!document.querySelector("script#model-viewer")) {
      const script = document.createElement("script");
      script.id = "model-viewer";
      script.type = "module";
      script.src =
        "https://unpkg.com/@google/model-viewer/dist/model-viewer.min.js";
      document.head.appendChild(script);
    }
  }, []);

  // Fetch folder name
  useEffect(() => {
    const fetchFolderName = async () => {
      try {
        const response = await fetch("https://www.d-rosa.ai/appname");
        const data = await response.json();
        setFolderName(data.foldername || "default");
      } catch (error) {
        console.error("Error fetching folder name:", error);
      }
    };
    fetchFolderName();
  }, []);

  const handleChange = (e) => {
    setInputs({ ...inputs, [e.target.name]: e.target.value });
  };

  // Generate STEP file
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(
        "https://www.d-rosa.ai/customchairdesign",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            file_path: `/var/www/myflaskapp/flask_static/${userEmail}/${folderName}`,
            user_email: userEmail,
            folder_path: folderName,
            seat_width: parseInt(inputs.seat_width),
            seat_depth: parseInt(inputs.seat_depth),
            seat_thickness: parseInt(inputs.seat_thickness),
            leg_height: parseInt(inputs.leg_height),
            leg_width: parseInt(inputs.leg_width),
            backrest_height: parseInt(inputs.backrest_height),
            backrest_thickness: parseInt(inputs.backrest_thickness),
            armrest_height_above_seat: parseInt(inputs.armrest_height_above_seat),
            armrest_thickness: parseInt(inputs.armrest_thickness),
            armrest_width: parseInt(inputs.armrest_width),
          }),
        }
      );

      if (response.ok) {
        const data = await response.json();
        setCustomchairUrl(data.customchairurl || "");
        alert("Custom Chair design is completed!!");
      } else {
        console.error("Error sending Custom Chair data");
      }
    } catch (error) {
      console.error("Error in handleSubmit:", error);
    }
  };

  // Convert STEP ? GLB and display
  const handleView = async () => {
    try {
      const response = await fetch("https://www.d-rosa.ai/ChairtoGlbb", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          file_path: `/var/www/myflaskapp/flask_static/${userEmail}/${folderName}`,
          user_email: userEmail,
          folder_path: folderName,
        }),
      });

      if (response.ok) {
        const data = await response.json();
        setGlbUrl(data.glburl || "");
      } else {
        console.error("Error converting Chair to GLB");
      }
    } catch (error) {
      console.error("Error in handleView:", error);
    }
  };

  return (
    <div id="image-container">
      <center>
        <h2 className="center-heading">Custom Chair Design</h2>
      </center>
      <p>Signed in as: {userEmail}</p>

      {/* Input form */}
      <form onSubmit={handleSubmit}>
        <input
          type="number"
          name="seat_width"
          value={inputs.seat_width}
          onChange={handleChange}
          placeholder="Seat Width"
          className="w-full p-2 border rounded"
          required
        />
        <br /><br />
        <input
          type="number"
          name="seat_depth"
          value={inputs.seat_depth}
          onChange={handleChange}
          placeholder="Seat Depth"
          className="w-full p-2 border rounded"
          required
        />
        <br /><br />
        <input
          type="number"
          name="seat_thickness"
          value={inputs.seat_thickness}
          onChange={handleChange}
          placeholder="Seat Thickness"
          className="w-full p-2 border rounded"
          required
        />
        <br /><br />
        <input
          type="number"
          name="leg_height"
          value={inputs.leg_height}
          onChange={handleChange}
          placeholder="Leg Height"
          className="w-full p-2 border rounded"
          required
        />
        <br /><br />
        <input
          type="number"
          name="leg_width"
          value={inputs.leg_width}
          onChange={handleChange}
          placeholder="Leg Width"
          className="w-full p-2 border rounded"
          required
        />
        <br /><br />
        <input
          type="number"
          name="backrest_height"
          value={inputs.backrest_height}
          onChange={handleChange}
          placeholder="Backrest Height"
          className="w-full p-2 border rounded"
          required
        />
        <br /><br />
        <input
          type="number"
          name="backrest_thickness"
          value={inputs.backrest_thickness}
          onChange={handleChange}
          placeholder="Backrest Thickness"
          className="w-full p-2 border rounded"
          required
        />
        <br /><br />
        <input
          type="number"
          name="armrest_height_above_seat"
          value={inputs.armrest_height_above_seat}
          onChange={handleChange}
          placeholder="Armrest Height above Seat"
          className="w-full p-2 border rounded"
          required
        />
        <br /><br />
        <input
          type="number"
          name="armrest_thickness"
          value={inputs.armrest_thickness}
          onChange={handleChange}
          placeholder="Armrest Thickness"
          className="w-full p-2 border rounded"
          required
        />
        <br /><br />
        <input
          type="number"
          name="armrest_width"
          value={inputs.armrest_width}
          onChange={handleChange}
          placeholder="Armrest Width"
          className="w-full p-2 border rounded"
          required
        />
        <br /><br />
        <button type="submit">Submit</button>
      </form>

      <br />
      <p>Custom Chair File Path: {customchairUrl}</p>
      <br />

      {customchairUrl && (
        <>
          <button
            onClick={handleView}
            style={{ padding: "10px 20px", fontSize: "16px" }}
          >
            View
          </button>
          <br /><br />
          <a href={customchairUrl} target="_blank" rel="noopener noreferrer">
            <button style={{ padding: "10px 20px", fontSize: "16px" }}>
              Download
            </button>
          </a>
        </>
      )}

      {glbUrl && (
        <div style={{ marginTop: "20px" }}>
          <h3>3D Custom Chair Model</h3>
          <model-viewer
            src={glbUrl}
            alt="Custom Chair model"
            auto-rotate
            camera-controls
            ar
            shadow-intensity="1"
            style={{
              width: "600px",
              height: "400px",
              backgroundColor: "pink",
            }}
          ></model-viewer>
        </div>
      )}

      <br />
      <button onClick={() => navigate("/previous-page")}>
        <img src={backButton} alt="Back" width="60" height="60" />
      </button>

      <footer className="footer-section">
        <div className="text-6">
          &copy; 2022 HYDAX Hydraulics Pvt. Ltd. All rights reserved.
        </div>
      </footer>
    </div>
  );
};

export default CustomChair;
